import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type ReportingUiScopeMathsFluencySprintsStudentRoute from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/student/route'
import type { NormalizedInterval } from 'date-fns'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  queryParams = {
    category: {
      replace: true,
    },
    sort: {
      replace: true,
    },
  }

  @service studentEvents!: StudentEventsService

  async model() {
    const { period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor(
      'reporting.ui-scope.maths.fluency-sprints.student',
    ) as ModelFor<ReportingUiScopeMathsFluencySprintsStudentRoute>

    const statsScope: StudentScope = { scope: 'student', ids: [student.id] }

    const product: LegacyProductMs = 'maths'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return { ...stats }
  }

  makeStatsRequests(product: LegacyProductMs, scope: StudentScope, period: NormalizedInterval) {
    return RSVP.hash({
      mentalMinuteStudent: this.studentEvents.mentalMinuteStudent(product, scope, period),
    })
  }
}
